import styled from 'styled-components'
import Slider from 'rc-slider'
import { theme } from 'src/styles/theme'
import 'rc-slider/assets/index.css'

function RangeSlider({ range = false, min = 0, max = 100, step = 1, ...props }) {
  return (
    <RangeSliderWrapper>
      <Slider
        range={range}
        min={min}
        max={max}
        step={step}
        trackStyle={{ backgroundColor: theme.colors.action.DEFAULT, height: 4 }}
        handleStyle={{
          borderColor: theme.colors.action.DEFAULT,
          height: 16,
          width: 16,
          backgroundColor: theme.colors.action.DEFAULT,
        }}
        railStyle={{ backgroundColor: theme.colors.accentMid, height: 4 }}
        {...props}
      />
    </RangeSliderWrapper>
  )
}

const RangeSliderWrapper = styled.div`
  width: 100%;
`

export default RangeSlider
